import { render, staticRenderFns } from "./VuesticModal.vue?vue&type=template&id=827a403a&scoped=true&"
import script from "./VuesticModal.vue?vue&type=script&lang=js&"
export * from "./VuesticModal.vue?vue&type=script&lang=js&"
import style0 from "./VuesticModal.vue?vue&type=style&index=0&id=827a403a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827a403a",
  null
  
)

export default component.exports